/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';
export const markPlayStatus = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS_OLD, data).then((res: IOutput) => {
        return res.data;
    });
};
